<template>
  <div class="container-fluid" id="main_car_dashboard">
    <fullscreen
      ref="fullscreen"
      @change="fullscreenChange"
      :fullscreen.sync="fullscreen"
    >
      <!-- Initial Loading  -->
      <div v-if="firstTimeNotification" id="first-load-container">
        <div id="first-load-content">
          <img
            id="first-time-image"
            src="/static/img/About-Dashboard-image.png"
            alt="First time load"
            srcset=""
          />
          <div id="first-time-load-info">
            <h3>Initializing...</h3>
            <p>
              Getting the platform ready for the first time takes longer, so you
              can have seamless offline access to it later.
            </p>
          </div>
        </div>
      </div>
      <div id="loading-screen" v-show="!isChartRendered">
        <div class="fancy-loader">
          <span>LOADING</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="lds-comets"
            width="200px"
            height="200px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
          >
            <g transform="rotate(162.228 50 50)">
              <animateTransform
                attributeName="transform"
                type="rotate"
                repeatCount="indefinite"
                values="360 50 50;240 50 50;120 50 50;0 50 50"
                keyTimes="0;0.333;0.667;1"
                dur="1s"
                keySplines="0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1"
                calcMode="spline"
              />
              <path
                fill="#41918E"
                d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
              />
              <path
                fill="#E0E0E0"
                d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
              />
              <path
                fill="#80CBC4"
                d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
              />
            </g>
          </svg>
        </div>
      </div>
      <div
        class="text-xs-center"
        style="margin-top: 13em"
        v-show="!isDataLoadedFirstTime"
      >
        <v-progress-circular
          indeterminate
          v-bind:size="70"
          v-bind:width="7"
          color="purple"
        ></v-progress-circular>
      </div>

      <div id="nav_cpanel" class="top_navigation_cpanel row" ref="nav_cpanel">
        <!-- Header and Search Bar -->
        <div class="col-xs-12" id="car_top_selector_container">
          <div id="top_of_page" class="hidden"></div>

          <div class="col-xs-12 col-md-5">
            <div
              class="col-xs-12 col-sm-12 col-md-10 title_placement"
              style="padding-left: 15px"
            >
              <h4>ANALYSIS OF KEY HEALTH INDICATORS</h4>
            </div>
          </div>
          <div class="col-xs-12 col-md-7 top-navbar">
            <div class="col-xs-12 col-sm-12 col-md-8 compare-multiselect">
              <label class="hidden">{{ multiselectPlaceholderComputed }}</label>
              <span style="">
                <multi-select
                  data-step="2"
                  data-intro="<b>Select Indicator</b><p>You can select a health indicator by clicking on this drop-down menu</p>"
                  v-model="selectedIndicator"
                  :options="optionIndicators"
                  group-values="indicators"
                  group-label="programArea"
                  :group-select="false"
                  :show-labels="true"
                  @close="closedMultiselect(selectedIndicator.name)"
                  :group-collapsible="collapsible"
                  @open="openedMultiselect"
                  @search-change="multiselectSearch"
                  :group-collapsible-expanded="false"
                  :allow-empty="false"
                  :placeholder="multiselectPlaceholder"
                  track-by="name"
                  label="name"
                  ><span slot="noResult"
                    >Oops! No elements found. Change the search query.</span
                  ></multi-select
                >
              </span>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-3 year-multiselect compare-multiselect"
            >
              <multi-select
                data-step="3"
                data-position="left"
                data-intro="<b>Select Location </b><p>Click here to select your desired location from the drop-down menu</p>"
                v-model="selectedState"
                :options="optionStates"
                :hide-selected="false"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                :placeholder="statePlaceholder"
                @close="closedStateMultiselect(selectedState)"
                @open="openedStateMultiselect"
              ></multi-select>
            </div>
          </div>
        </div>
        <keep-alive>
          <transition name="fade">
            <!-- <div class="row" v-show="openCPanel" id="ctrl-panel-elements">
              <div class="col-xs-12 c-panel-element">
                Control Panel Elements: Please don't delete -->

            <!-- <div class="col-xs-4 col-sm-4 col-md-2">
                  <span style="height: 100%">
                    <multi-select disabled v-model="comparisonSelectedSource" :options="optionSources" :hide-selected="false" :searchable="true" :allow-empty="true" :show-labels="false" placeholder="Search data sources"><span slot="noResult">Oops! No elements found. Change the search query.</span></multi-select>
                  </span>
                </div>
                <div class="col-xs-4 col-sm-4 col-md-1">
                  <span style="height: 100%">
                    <multi-select disabled v-model="selectedYear" :options="optionYear" :hide-selected="false" :searchable="true" :allow-empty="true" :show-labels="false" placeholder=""></multi-select>
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-3">
                  <section class="buttons has-addons">
                    <button class="button is-medium is-raised is-default" >
                      Confirm
                    </button>
                    <button class="button is-medium is-default" >
                      Confirm
                    </button>
                    <button class="button is-medium is-default">
                      Confirm
                    </button>
                  </section>
                </div>
                <div class="column is-4">
                  <section class="buttons has-addons">
                    Compare
                    <button class="material-button-raised is-default">
                      Indicators
                    </button>
                    <button class="material-button-raised is-success">
                      Data sources
                    </button>
                    <button class="material-button-raised is-grey">
                      Periods
                    </button>
                  </section>
                </div>
                <div class="column is-2">
                  IHME Uncertainty
                  <b-switch v-model="computeUncertaintyTruthVal"
                    @click.native.prevent.stop="plotUncertainty($event)"
                    type="is-success">
                  </b-switch>
                </div>
                <div class="column is-3">
                  <span>
                    <b>SDG Targets:</b>
                    <span class="badge badge-error" style="width: 10px; height: 17px;">
                      <small></small>
                    </span>&nbsp;On target
                    <span class="badge badge-success" style="width: 10px; height: 17px;">
                      <small></small>
                    </span>&nbsp;Not on target

                  </span>
                </div>
              </div>
            </div> -->
          </transition>
        </keep-alive>
      </div>

      <!-- Mobile Phone Detected -->
      <div class="visible-xs-block">
        <v-alert v-model="alertMobile" dismissible color="warning" outline>
          <div style="display: flex">
            <v-icon>phone_iphone</v-icon>
            <p style="margin-left: 5px">
              <b>Mobile device detected</b><br /><br />For the best experience,
              please use this platform on your laptop/desktop.
            </p>
          </div>
        </v-alert>
      </div>

      <!-- Dashboard tables, charts and graphs start here ... -->

      <div
        id="browserSupport"
        v-if="detect"
        class="col-lg-4 col-md-7 col-sm-6 col-xs-12"
      >
        <button
          v-on:click="closeAlert()"
          style="font-size: 20px"
          type="button"
          class="close mt-2"
          data-dismiss="#browserSupport"
        >
          <span aria-hidden="true" class="mb-4 mt-4 pt-4 pr-4">&times;</span>
        </button>
        <h4 class="mt-4 pl-2">
          <img src="/static/img/browser.png" /><strong class="alertBold"
            >Unsupported Browser!
          </strong>
        </h4>

        <p class="p-4 pl-2">
          Looks like you are using a browser that is not supported, so you may
          experience some problems.
        </p>
        <p class="pb-4 pl-2">
          Please use <strong class="alertBold">Google Chrome</strong> browser
          for the best experience with <br />
          MSDAT Platform.
        </p>
      </div>
      <div class="row" v-show="isDataLoadedFirstTime" id="firstRow">
        <div
          :class="{
            'col-xs-12 col-md-11': barChartHidden,
            'col-sm-12 col-md-8': !barChartHidden,
          }"
          id="firstRow_sec1a"
        >
          <!-- :indicatorOptions="optionIndicators" -->
          <!-- Table Component -->
          <table-component
            :selectedIndicator56="selectedIndicator.name"
            :uncertaintyData="estimatesData"
            v-on:dataSourceForChart="chartSourceData"
            v-on:toggleClicked="toggleClicked"
            v-on:IHMEtoggleClicked="IHMEtoggleClicked"
            v-on:indicatorRelatives="indicatorRelatives"
            v-on:plotUncertainty="plotUncertainty"
            :meta_data="metaData"
            :indicatorMetaData="indicatorMetaData"
            :sourceMetaData="sourceMetaData"
            :appData="lsData"
          >
          </table-component>

          <!-- Line Chart -->
          <line-chart
            :uncertaintyData="estimatesData"
            :appData="lsData"
            :isToggleClickedVal="isToggleClicked"
            v-on:chartRendered="chartRendered"
            :isIHMEtoggleClickedVal="isIHMEtoggleClicked"
            :meta_data="metaData"
            v-on:compareIndicators="compareIndicators"
          >
          </line-chart>
          <!-- <slide5-sub4 :uncertaintyData="estimatesData" v-show="showIHMEEstimate"></slide5-sub4> -->
          <div class="hidden"><label for=""></label></div>
        </div>
        <!-- <div class="line-breaker">&nbsp;</div> -->
        <div
          :class="{
            'col-sm-12 col-md-4': !barChartHidden,
            'col-sm-1 col-md-1': barChartHidden,
          }"
          id="firstRow_sec1b"
          style="box-sizing: border-box"
        >
          <bar-chart-component
            v-on:optionYear="regionalChartYearOptions"
            v-on:selectedYear="changeDashboardState"
            v-on:plotData="getMapPlotData"
            v-on:callerName="getCallerComponent"
            :appData="lsData"
            :metaData="metaData"
            :stateClicked="selectedState"
            :sourceOptions="zonalSourcesOptions"
            :lgaData="lgaData"
            :dashboardStateOptions="dashboardStateOptionsArray"
            v-on:barChartBoolValue="hideBarChartClicked"
          >
          </bar-chart-component>
        </div>
      </div>

      <!-- <div v-show="loadingbar" style="padding-top:20px; padding-bottom:10px">
          <p align="center" ><img src="http://demo.itsolutionstuff.com/plugin/loader.gif">Loading</p>
        </div>

          <br>
          <br>
          <br>
         <div v-show="loading"> -->
      <!-- Zonal Section begin -->
      <div class="html2pdf__page-break"></div>

      <div id="zonalChart" style="position: relative; top: -60px"></div>
      <div class="row text-center web-features zonal-section">
        <div id="zonal-title"><h5>ZONAL SECTION</h5></div>

        <div class="zonal-hide-button">
          <button
            class="material-button-raised pull-left"
            @click="showMore('zonal')"
            style="
              box-shadow: 0 0 5px gray;
              color: black;
              border-radius: 0;
              margin-right: 30px;
            "
          >
            <span style="font-size: 11px; font-family: 'Open Sans'"
              >Click to {{ showMoreMsg }}</span
            >
          </button>
        </div>
      </div>
      <div class="line-breaker">&nbsp;</div>

      <div class="row web-features" v-show="showMoreFeatures">
        <div data-v-step="7">
          <!-- Both barchart and maps -->
          <regions-chart
            :appData="lsData"
            :lgaData="lgaData"
            v-on:regionsChartYear="changeDashboardState"
            v-on:callerName="getCallerComponent"
            :yearOptions="regionalChartYearOptionsData"
            :selectedIndicator="selectedIndicator"
            :meta_data="metaData"
            :dashboardStateOptions="dashboardStateOptionsArray"
            :sources="optionSources"
          >
          </regions-chart>
        </div>
      </div>

      <div
        id="compare-section"
        class="compare-section-container row web-features"
        :class="{ 'compare-dataset-heading': compareSectionColorClass }"
        style=""
      >
        <div class="compare-heading col-xs-12 col-md-12">
          <div class="col-xs-12 col-md-8" style="padding-left: 30px">
            <span class="">
              <label class="white--text">{{
                isElementToCompareIndicator
                  ? " Multi-Dataset Comparison Section"
                  : "Multi-Source Indicator Comparison Section"
              }}</label>
            </span>
          </div>
          <div class="col-xs-12 col-md-2">
            <div class="col-md-12" v-show="showComponents">
              <multi-select
                v-model="$store.state.CAR.selectedState"
                :options="optionStates"
                :hide-selected="false"
                :searchable="true"
                style="transform: scale(0.9)"
                :allow-empty="false"
                :show-labels="false"
                :placeholder="comparisonSelectedStatePlaceholder"
                @open="openedCompareStateMultiselect()"
                @close="
                  closedCompareStateMultiselect($store.state.CAR.selectedState)
                "
              >
                <span slot="noResult"
                  >Oops! No elements found. Change the search query.</span
                >
              </multi-select>
            </div>
          </div>
          <div
            class="col-xs-12 col-md-2"
            style="display: flex; justify-content: center"
          >
            <button
              class="material-button-raised pull-left"
              @click="showMore('compare')"
              style="box-shadow: 0 0 5px gray; color: black; border-radius: 0"
            >
              <span
                style="font-size: 11px; font-family: 'Open Sans', sans-serif"
                >Click to {{ showCompareMsg }}</span
              >
            </button>
          </div>
        </div>
        <!-- Comparism Section Starts here -->
        <div class="web-features" style="margin-top: 2px">
          <span
            v-show="showComponents"
            :class="{ 'compare-dataset': compareSectionColorClass }"
          >
            <!-- <compare-section
                v-on:componentTypeArray="getComponentTypeArray"
                :singleMapSource="comparisonSelectedSource"
                :dataSources="comparisonSelectedSource"
                :selectedIndicator="selectedIndicator.name"
                :appData="lsData"
                :selectedState="comparisonSelectedState"
                :compType="componentType"
                :comparismType="elementToCompare"
                :relativeIndicators="relativeIndicators"
                :relativeIndicatorsValues="relativeIndicatorsValues"
                :regionalChartYearOptionsData="regionalChartYearOptionsData"
                :optionIndicators="optionIndicators">
              </compare-section> -->
            <span v-if="getRelatedIndicators.length">
              <CompareSec
                :key="index"
                v-for="(relatedIndicator, index) in getRelatedIndicators"
                :relatedIndicator="relatedIndicator"
              ></CompareSec>
            </span>
          </span>
          <div class="html2pdf__page-break"></div>
        </div>
      </div>
      <div id="datasets" style="position: relative; top: -60px"></div>
      <div class="html2pdf__page-break"></div>
      <div
        id="bottom_of_page"
        class="web-features row"
        style="margin-bottom: 20px"
      >
        <div class="col-xs-12 col-md-12" data-v-step="9">
          <column-chart
            v-on:columnChartSource="changeDashboardState"
            v-on:columnChartIndicator="changeDashboardState"
            v-on:callerName="getCallerComponent"
            :optionsIndicator="optionIndicators"
            :optionSources="optionSources"
            :appData="lsData"
            :meta_data="metaData"
            :dashboardStateOptions="dashboardStateOptionsArray"
            :contextSelectedIndicator="selectedIndicator"
          >
          </column-chart>
        </div>
      </div>
      <!-- </div> -->

      <div class="row web-features"></div>
      <b-modal :active.sync="shareButtonClicked" has-modal-card>
        <form action="">
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">SHARE PLATFORM</p>
            </header>
            <section class="modal-card-body">
              <div class="row" v-if="!loadingURLIcon && !errorFetchingURL">
                <div class="col-md-6 col-sm-12 share-copybox">
                  <p>
                    COPY LINK:
                    <span v-if="linkCopied" style="color: #3478b6"
                      >LINK COPIED</span
                    >
                  </p>
                  <div class="field row">
                    <div class="control has-icons-left col-xs-10">
                      <input
                        id="urlInput"
                        class="input"
                        type="text"
                        placeholder="Share URL"
                        v-bind:value="shareURL"
                        readonly
                      />
                      <span
                        class="icon is-small is-left"
                        style="margin-left: 20px"
                      >
                        <v-icon>fas fa-link</v-icon>
                      </span>
                    </div>
                    <div class="share-clipboard-button col-xs-2">
                      <button
                        title="Copy to clipboard"
                        @click.prevent="copyURL"
                      >
                        <v-icon medium>fas fa-clipboard</v-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 share-socialicons">
                  <p>SHARE VIA</p>
                  <div class="share-icons col-sm-12 row">
                    <div class="col-sm-3">
                      <i @click="shareViaLinkedin">
                        <a
                          class="fab fa-linkedin icon-linkedin vc_icon_element"
                          color="white"
                        ></a>
                      </i>
                    </div>
                    <div class="col-sm-3">
                      <i id="icon-email" @click="shareViaEmail">
                        <a
                          class="fas fa-envelope icon-email vc_icon_element"
                          color="white"
                        ></a>
                      </i>
                    </div>
                    <div class="col-sm-3">
                      <i id="icon-twitter" @click="shareViaTwitter">
                        <a
                          class="fab fa-twitter icon-twitter vc_icon_element"
                          color="white"
                        ></a>
                      </i>
                    </div>
                    <div class="col-sm-3">
                      <i id="icon-facebook" @click="shareViaFacebook">
                        <a
                          class="fab fa-facebook-square icon-facebook vc_icon_element"
                          color="white"
                        ></a>
                      </i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="width: 57px; margin: 0 auto"
                v-else-if="loadingURLIcon && !errorFetchingURL"
              >
                <v-progress-circular
                  indeterminate
                  v-bind:size="50"
                  v-bind:width="4"
                  color="blue"
                ></v-progress-circular>
              </div>
              <div style="text-align: center" v-else>
                <p style="color: red; font-size: 18px">
                  <b>Something went wrong.</b><br />Please check your internet
                  connection and try again
                </p>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button
                class="button is-danger pull-right"
                type="button"
                @click="shareButtonClicked = false"
              >
                CLOSE
              </button>
            </footer>
          </div>
        </form>
      </b-modal>
    </fullscreen>

    <!-- scroll down and scroll up -->
    <button
      v-show="!isTourActive"
      class="material-button-raised goto-top-of-page"
      id="scrollToTopButton"
      v-tooltip.left="'Go to top of page'"
      @click="scrollup()"
    >
      <v-icon class="mid-align" left dark large color="white"
        >keyboard_arrow_up</v-icon
      >
    </button>
    <button
      v-show="!isTourActive"
      class="material-button-raised goto-top-of-page"
      id="scrollToButtomButton"
      v-tooltip.left="'Go to bottom of page'"
      @click="scrolldown()"
    >
      <v-icon class="mid-align" left dark large color="white"
        >keyboard_arrow_down</v-icon
      >
    </button>

    <div>
      <!-- Tour -->

      <div>
        <!-- Contains the first modal that loads when you visit for the first time-->
        <div v-show="!firstTimeNotification">
          <b-modal has-modal-card :active.sync="isTourActive">
            <div class="modal-card">
              <div class="modal-card-head styleBody">
                <span class="close-year-modal is-danger pull-right">
                  <i @click="isTourActive = false">
                    <a
                      class="fas fa-times-circle vc_icon_element_close"
                      color="#ff3860"
                    ></a> </i
                ></span>
              </div>
              <div class="modal-card-body styleBody">
                <div class="">
                  <carousel
                    :items="1"
                    :margin="10"
                    :autoplay="false"
                    :autoplayTimeout="5000"
                    :dots="true"
                    :nav="true"
                    :lazyLoad="true"
                    :navText="owlNavText"
                  >
                    <!-- :lazyLoad=true :navText='["<",">"]'> -->

                    <div>
                      <section>
                        <div class="row nanleModal">
                          <p>
                            <img
                              src="static/img/tourIcons/Group441.png"
                              style="
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                width: 45%;
                                height: 30%;
                              "
                            />
                          </p>
                          <p class="lead">Welcome to</p>

                          <p class="my-0 pb-2" style="font-size: 1.4em">
                            <strong
                              >The Multi-Source Data <br />
                              Analytics and Triangulation Platform
                            </strong>
                          </p>

                          <p>
                            The Multi-Source Data Analytics and Triangulation
                            (MSDAT) Platform is owned by the Federal Ministry of
                            Health and was developed to provide a single
                            transparent view of key health indicators against
                            multiple data sources - routine, non-routine and
                            estimates.
                          </p>

                          <p class="pt-2 mb-0 pb-0">
                            <strong>Watch tutorial video</strong>
                          </p>
                          <a
                            style="text-decoration: none"
                            target="_blank"
                            href="https://www.youtube.com/watch?v=k75zoZ1SXgk"
                          >
                            <strong>youtube.com/watch?v=k75zoZ1SXgk</strong>
                          </a>
                          <p class="nanleHr"></p>
                        </div>
                      </section>
                    </div>
                    <div class="styleBody">
                      <section>
                        <div class="row nanleModal2">
                          <br /><br />
                          <h2 class="text-left">
                            This platform contains four main sections:
                          </h2>

                          <!-- <ol class=" py-1" style='list-style-type:lower-roman'>
              <li> <p>Overview section</p></li>
              <li> <p>Zonal section</p></li>
              <li> <p>Multi-Indicator Comparison section</p></li>
              <li> Multi-Dataset Comparison section <img src="static/img/tourIcons/Group-1.png" style="
                float:right;
                display: block;
                margin-left: auto;
                margin-right: auto;
                width: 35%;
                height:35%;"/></li>

            </ol> -->

                          <div>
                            <p>i. Overview Section</p>
                            <p>ii. Zonal Section</p>
                            <p>
                              iii. Multi-Source Indicator Comparison Section
                            </p>
                            <p>iv. Multi-Dataset Comparison Section</p>
                            <p>
                              <img
                                src="static/img/tourIcons/Group-1.png"
                                style="
                                  float: right;
                                  display: block;
                                  margin-left: auto;
                                  margin-right: auto;
                                  width: 35%;
                                  height: 35%;
                                "
                              />
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div>
                      <section>
                        <div class="row nanleModal">
                          <br /><br />
                          <div class="nanleModalImage">
                            <img src="static/img/tourIcons/main_section_.png" />
                          </div>
                          <div class="nanleModal">
                            <p>Section 1:</p>

                            <h1>Overview Section</h1>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div>
                      <section>
                        <div class="row nanleModal">
                          <br /><br />
                          <div class="nanleModalImage">
                            <img src="static/img/tourIcons/zonal_section.png" />
                          </div>
                          <br />
                          <div class="">
                            <p>Section 2:</p>
                            <h1>Zonal Section</h1>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div>
                      <section>
                        <div class="row nanleModal">
                          <br /><br />
                          <div class="nanleModalImage">
                            <img
                              src="static/img/tourIcons/multi_indicator_comparison.png"
                            />
                          </div>
                          <br />
                          <div class="">
                            <p>Section 3:</p>
                            <h1>Multi-Source Indicator Comparison Section</h1>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div>
                      <section>
                        <div class="row nanleModal">
                          <br /><br />
                          <div class="nanleModalImage">
                            <img src="static/img/tourIcons/multi_dataset.png" />
                          </div>
                          <br />
                          <div class="">
                            <p>Section 4:</p>
                            <h1>Multi-Dataset Comparison Section</h1>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div>
                      <section>
                        <div class="row nanleModal">
                          <br /><br />
                          <div>
                            <img
                              src="static/img/tourIcons/Group472.png"
                              style="
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                width: 35%;
                                height: 35%;
                              "
                            />
                          </div>
                          <div class="">
                            <h2>We value your feedback</h2>
                            <p>
                              Click on the icon situated on the right side of
                              the page to send us your feedback.
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div>
                      <section>
                        <div class="row nanleModal">
                          <br /><br />
                          <div>
                            <img
                              src="static/img/tourIcons/msdat_tourguide_help.jpg"
                              style="
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                width: 50%;
                              "
                            />
                          </div>
                          <div class="">
                            <p>
                              You can always play the tour guide <br />
                              from the menu bar and also visit the help page for
                              more tips.
                            </p>

                            <h2>Congratulations</h2>
                            <p>Have a wonderful experience</p>
                            <br />
                            <button
                              class="btn btn-danger"
                              @click="isTourActive = false"
                            >
                              Skip Tour Guide
                            </button>
                            <button
                              class="btn btn-success"
                              @click="
                                (isTourStarts = true), (isTourActive = false)
                              "
                              style="background-color: #007d53; color: white"
                            >
                              Start Tour Guide
                            </button>
                          </div>
                        </div>
                      </section>
                    </div>
                  </carousel>
                </div>
              </div>
            </div>
          </b-modal>
        </div>

        <b-modal has-modal-card :active.sync="isTourStarts">
          <div class="modal-card">
            <div
              class="modal-card-body modal-sm"
              style="width: 50%; margin-left: 26%"
            >
              <div class="row">
                <div class="col-xs-8 col-md-8">
                  <h1 style="font-size: 30px">Welcome!</h1>
                  <p style="font-size: 12px">
                    For a quick tour of the MSDAT platform key functions,
                    <b>click Next</b>
                  </p>
                  <br />
                  <button class="btn" @click="startTour()">Next ></button>
                </div>
                <div class="col-xs-4 col-md-4">
                  <img src="static/img/tour/group_410.png" />
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal has-modal-card :active.sync="contactForm" id="contactForm">
          <div @click="stopTimer()" class="modal-card">
            <div
              class="modal-card-body"
              style="
                max-width: 450.75px;
                margin: auto;
                padding-top: 15px;
                border-radius: 7px;
              "
            >
              <div class="col">
                <div>
                  <button
                    @click="contactForm = false"
                    class="pull-right"
                    style="display: block"
                  >
                    <v-icon>close</v-icon>
                  </button>
                </div>
                <div class="col-xs-12 col-md-12">
                  <h6 align="center">Nice to Meet You!</h6>
                </div>
              </div>
              <div class="col">
                <div class="col-xs-12 col-md-12">
                  <p
                    align="center"
                    style="
                      font-weight: 400;
                      font-size: 12px;
                      padding-bottom: 15px;
                    "
                  >
                    Welcome to the Multi-Source Data Analytics and
                    Triangulation<br />(MSDAT) Platform. Would you like to
                    <b
                      >stay informed about the platform by receiving the latest
                      updates?</b
                    >
                  </p>
                </div>

                <div class="col">
                  <div class="col-xs-12 col-md-12 col-sm-12">
                    <form v-on:submit.prevent="conformSend()">
                      <div>
                        <div class="" align="center">
                          <p style="font-weight: 100; font-size: 13px">
                            Leave us a few details to make that happen.
                          </p>
                          <br />
                          <p v-show="nofields" class="alert alert-warning">
                            The following fields are required: Name, Email
                            Address and Profession
                          </p>
                          <p
                            v-show="successmessage"
                            class="alert alert-success"
                          >
                            Thank you. We will keep you informed about the
                            latest updates to the MSDAT Platform.
                          </p>
                          <p v-show="errormessage" class="alert alert-danger">
                            An error occured, please try again later.
                          </p>
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Name *"
                              required
                              minlength="4"
                              v-model="contactFormFields.name"
                            />
                          </div>
                          <div class="form-group">
                            <input
                              type="email"
                              class="form-control"
                              placeholder="Email address *"
                              required
                              email
                              v-model="contactFormFields.email"
                            />
                          </div>
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Profession or Field or Work/Study *"
                              required
                              v-model="contactFormFields.profession"
                            />
                          </div>
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Organization"
                              v-model="contactFormFields.organization"
                            />
                          </div>
                          <!-- <div class="form-group">
                  <select class="form-control" v-model="contactFormFields.category">
                    <option value="">Select a Category *</option>
                    <option value="Suggestions">Suggestions</option>
                    <option value="Complaints">Complaints</option>
                    <option value="Ideas">Ideas</option>
                    <option value="General Feedback">General Feedback</option>
                  </select>
                </div>
                <div class="form-group">
                  <textarea required class="form-control" v-model="contactFormFields.comment" rows="4">Comment</textarea>
                </div> -->
                          <div class="form-group" style="padding-bottom: 13px">
                            <p style="font-weight: 400; font-size: 12px">
                              <input
                                type="checkbox"
                                v-model="contactFormFields.newsletter"
                                true-value="true"
                                false-value="false"
                              />
                              I would also like to help improve the platform by
                              giving my opinion and suggestions from time to
                              time.
                            </p>
                          </div>

                          <div align="center">
                            <p
                              align="center"
                              v-show="loader"
                              class="animated preFadeInUp fadeInUp"
                            >
                              <img
                                src="static/img/ajax-loader.gif"
                                style="height: 100px"
                              />
                            </p>
                            <button
                              class="btn"
                              style="
                                background-color: #007d53;
                                color: white;
                                box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.4);
                                border-color: #007d53;
                                width: 127.5px;
                                height: 41px;
                                margin-bottom: 15px;
                              "
                            >
                              Submit
                            </button>
                            <p>
                              <a
                                @click="contactForm = false"
                                style="
                                  color: #707070;
                                  font-weight: 300;
                                  font-size: 15px;
                                  padding-top: 15px;
                                "
                                >Maybe next time</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script src="../public/js/jquery3.1.1.min.js"></script>
<script src="../node_modules/bootstrap/dist/js/bootstrap.min.js"></script>
<script>
// Importing of necessary compoNents

import LineChart from "./lineChart";
import TableComponent from "./tableComponent";
import BarChartComponent from "./barChartComponent";
import axios from "axios";
import PlotMap from "./maptypes";
import PlotChart from "./chartTypes";
import BarChart from "./chartTypes/barChart";
// import sortObjects from '@/assets/js-on/sortObjects';
import html2pdf from "html2pdf.js";
import draggable from "vuedraggable";
import { chart_options3 } from "@/assets/js-on/highchart_options";
// import Sortable from 'sortablejs';
import Comments from "../components/comments";
import WidgetContainer from "../components/widgetContainer";
import VueCookies from "vue-cookies";
import { mapGetters, mapActions } from "vuex";
import { url_shortener, url_decode } from "@/assets/js-on/url_shortener";
import { log } from "async";
import MultiSelect from "@/assets/js-on/vue-multiselect";
import { indDB } from "../../../../main";

// const Swal = require('sweetalert2');
const platform = require("platform");

export default {
  name: "maincardashboard",
  components: {
    MultiSelect,
    draggable,
    PlotMap,
    PlotChart,
    BarChart,
    BarChartComponent,
    LineChart,
    TableComponent,
    RegionsChart: () => import("./regionsChart"),
    ColumnChart: () => import("./columnChart"),
    RegionsMap: () => import("./maptypes/region_states"),
    Comments,
    WidgetContainer,
    compareSection: () => import("./compareSection"),
    carousel: () => import("vue-owl-carousel"),
    CompareSec: () => import("./CompareSec"),
  },
  props: ["appData", "indicator_variables", "indicator_year"],
  //
  // indDB: indDB,
  data() {
    return {
      requestedBytes: 1024 * 1024 * 20, // 10MB
      loader: false,
      isOnline: window.navigator.onLine,
      // FullScreen
      fullscreen: false,
      alertMobile: true,
      detect: false,
      nofields: false,
      successmessage: false,
      errormessage: false,
      contactFormFields: {
        name: "",
        email_address: "",
        profession: "",
        organisation: "",
        newsletter: false,
        category: "",
        comment: "",
      },
      ndStateData: "",
      ndLgaData: "",
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      estimatesData: JSON.parse(this.$ls.get("estimates_dataset")),
      // lgaData: JSON.parse(this.$ls.get("lga_dataset")),
      lgaData: [],
      metaData: JSON.parse(this.$ls.get("meta_data_dataset")),
      sourceMetaData: JSON.parse(this.$ls.get("source_meta_dataset")),
      indicatorMetaData: JSON.parse(this.$ls.get("indicator_meta_dataset")),
      isDataLoadedFirstTime: false,
      showMoreFeatures: true,
      owlNavText: [
        "<i class='owlCar fa fa-angle-left ' ></i>",
        "<i class='owlCar fa fa-angle-right'></i>",
      ],
      // openCPanel: false,
      showIcon: false,
      barChartHidden: false,
      // isOpen: true,
      collapsible: true,
      elementToCompare: "source",
      isElementToCompareIndicator: false,
      optionYear: [],
      zonalYearOptions: [],
      zonalSourcesOptions: [
        "MICS",
        "NDHS",
        "NARHS",
        "NMIS",
        "NNHS",
        "NHMIS",
        "World Bank",
        "IHME",
        "WHO-GHO",
        "WUENIC",
        "PCCS",
        "UNAIDS",
        "NHSPSS",
        "NHA",
        "KDGHS",
        "NAIIS",
      ],
      zonalSelectedYear: "",
      zonalSelectedSource: "",
      shareButtonClicked: false,
      scrolledToBottom: false,
      isTourActive: true,
      isTourStarts: false,
      firstTimeNotification: false,
      // showIHMEEstimate: false,
      computeUncertaintyTruthVal: false,
      comparisonSelectedSource: "NHMIS",
      comparisonSelectedState: "National",
      mapComparisonSelectedSource: "NHMIS",
      comparisonSelectedIndicator: {
        name: "Skilled attendance at delivery or birth",
      },
      loading: false,
      optionSources: [
        "MICS",
        "NHMIS",
        "NNHS",
        "NDHS",
        "NMIS",
        "PCCS",
        "NARHS",
        "IHME",
        "World Bank",
        "WHO-GHO",
        "WUENIC",
      ],
      snackbar: true,
      regionalChartYearOptionsData: [],
      contactForm: false,
      showComponents: true,
      componentTypeArray: [],
      componentType: "Charts",
      specificComponentOptions: ["line", "column"],
      specificComponentType: "line",
      specificMapType: ["states", "states", "states"],
      specificChartType: ["line", "line", "line"],
      firstTimeUser: false,
      selectedOption: { name: "Option 4.1" },
      loadingbar: false,
      selectedYear: null,
      showMoreMsg: "hide zonal charts",
      showCompareMsg: "hide comparison charts",
      selectedIndicator: { name: "Skilled attendance at delivery or birth" },
      optionIndicators: [],
      headerObj: {},
      traceArray: [],
      dashboardState: {},
      plotData: {},
      // Api Links
      // apiUrl: "https://msdat-database.firebaseio.com/masterSheet.json",
      apiUrl: "https://car-dashboard-others.firebaseio.com/masterSheet.json",
      // targetUrl: "https://car-dashboard-others.firebaseio.com/targets.json",
      estimatesUrl:
        "https://car-dashboard-others.firebaseio.com/estimates.json",
      LGA_Url: "https://car-dashboard-others.firebaseio.com/car-lga-data.json",
      // LGA_Url: "https://car-dashboard-others.firebaseio.com/car-lga-data2.json",
      metaDataUrl: "https://car-dashboard-others.firebaseio.com/meta-data.json",
      // metaDataUrl: "https://msdat-database.firebaseio.com/meta-data-test.json",
      dataSourceUrl:
        "https://car-dashboard-others.firebaseio.com/data-source-meta-data.json",
      // dataSourceUrl: "https://msdat-database.firebaseio.com/data-source-meta-data.json",
      indicatorUrl:
        "https://car-dashboard-others.firebaseio.com/indicator-meta-data.json",
      // indicatorUrl: "https://msdat-database.firebaseio.com/indicator-meta-data-test.json",
      //numerator-denominator api url
      // ndStateUrl: "https://car-dashboard-others.firebaseio.com/ndlga.json",
      // ndLgaUrl: "https://car-dashboard-others.firebaseio.com/ndState.json",
      nhmisMonthlyUrl:
        "https://car-dashboard-others.firebaseio.com/nhmis_monthly.json",
      selectedSource: "null",
      sourceClickProp: null,
      dataSourceForChart: [],
      tableColumnHeaderAttr: null,
      //Default Selected National
      selectedState: "National",
      //Select options
      optionStates: [
        "National",
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Bayelsa",
        "Benue",
        "Borno",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kano",
        "Katsina",
        "Kebbi",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara",
      ],
      options: [],
      value: [],
      isToggleClicked: false,
      isIHMEtoggleClicked: false,
      relativeIndicators: [],
      callerComponentName: "",
      linkCopied: false,
      shareURL: "",
      shareURLHash: "",
      shortURL: "",
      loadingURLIcon: false,
      errorFetchingURL: false,
      params: this.$store.getters.getParams,
      urlParams: "",
      shortURL: "",
      urlParam: this.$route.params.sharer,
      dashboardStateOptions: "",
      dashboardStateOptionsArray: [],
      multiselectPlaceholder: "",
      statePlaceholder: "",
      mapPlotData: "",

      compareIndicatorMultitselectPlaceholder: "",
      comparisonSelectedSourcePlaceholder: "",
      comparisonSelectedStatePlaceholder: "",

      compareSectionColorClass: false,
      config_radius: 3,
      isChartRendered: false,
      timer: "",
    };
  },
  methods: {
    ...mapActions("CAR", ["storeLgaData"]),
    closeAlert() {
      this.detect = false;
    },
    detectBrowser() {
      //for opera
      let isOpera =
        (!!window.opr && !!opr.addons) ||
        !!window.opera ||
        navigator.userAgent.indexOf(" OPR/") >= 0;
      // Firefox 1.0+
      let isFirefox = typeof InstallTrigger !== "undefined";
      // Safari 3.0+ "[object HTMLElementConstructor]"
      let isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
          return p.toString() === "[object SafariRemoteNotification]";
        })(
          !window["safari"] ||
            (typeof safari !== "undefined" && safari.pushNotification)
        );
      // Internet Explorer 6-11
      let isIE = /*@cc_on!@*/ false || !!document.documentMode;
      // Edge 20+
      let isEdge = !isIE && !!window.StyleMedia;
      // Chrome 1+
      let isChrome = !!window.chrome;
      // Blink engine detection
      let isBlink = (isChrome || isOpera) && !!window.CSS;

      // rework for browser(s) detection

      // if (isChrome || isBlink) {
      //   return true;
      // } else if (isSafari || isFirefox || isOpera || isOpera || isEdge) {
      //   return false;
      // }
      //rework for browser detection
      if (platform.name == "Chrome") {
        return true;
      } else {
        return false;
      }

      // if((isChrome === true && isBlink===true)&& isOpera===false && isFirefox === false && isSafari === false && isOpera === false && isEdge === false){
      //   return true;
      // } else {
      //   return false;
      // }
    },
    conformSend() {
      const headers = {
        Authorization: "Bearer 054d817a3b1a3a2c5edf656959334969e1264e84",
      };
      this.loader = true;
      if (
        this.contactFormFields.name != "" ||
        this.contactFormFields.email != "" ||
        this.contactFormFields.profession != ""
      ) {
        if (
          this.contactFormFields.name &&
          this.contactFormFields.email &&
          this.contactFormFields.profession
        ) {
          axios
            .post(
              "http://135.181.212.168:9234/api/account/contact/",
              this.contactFormFields,
              { headers }
            )
            .then((response) => {
              // console.log(this.apiFormat(this.contactFormFields))
              if (response.status === 201) {
                // this.successmessage = true;
                this.loader = false;
                this.successmessage = true;
                this.contactFormFields.name = "";
                this.contactFormFields.email = "";
                this.contactFormFields.profession = "";
                this.contactFormFields.newsletter = false;
                this.contactFormFields.organization = "";
                //location.reload(true);

                self = this;
                setTimeout(function () {
                  // console.log('close');
                  self.closeContactform();
                }, 4000);
                // this.contactForm = false;

                // setTimeout(() => {
                // this.formShow = false;
                // },4000);
              } else {
                this.errormessage = true;
                this.loader = false;
              }
            })
            .catch((e) => {
              // console.log(e);
              this.errormessage = true;
              this.loader = false;
            });
          // console.log("testing form");
        }
      } else {
        this.nofields = true;
      }
    },
    closeContactform() {
      this.contactForm = false;
    },

    apiFormat(value) {
      var parentArray = [];
      var childArray = [];
      childArray.push(
        value.name,
        value.email,
        value.profession,
        value.organization,
        value.category,
        value.comment,
        value.newsletter
      );
      parentArray.push(childArray);
      return JSON.stringify({ data: parentArray });
    },

    nextItem() {
      var owl = $(".owl-carousel");
      $(".owl-carousel").next();
      if (event.keyCode == 37 || event.which == 37) {
        $(".owl-prev").trigger("click");
      } else if (event.keyCode == 39 || event.which == 39) {
        $(".owl-next").trigger("click");
      }
    },
    /**
     *
     * toggle fullscreen
     */
    toggle() {
      // this.$refs['fullscreen'].background = "green";
      // console.log("Here");

      this.$refs["fullscreen"].toggle();
    },

    async clearLocalStorage() {
      //Remove local files
      this.$ls.remove("car_other_dataset");
      this.$ls.remove("estimates_dataset");
      this.$ls.remove("lga_dataset");
      this.$ls.remove("meta_data_dataset");
      this.$ls.remove("source_meta_dataset");
      this.$ls.remove("indicator_meta_dataset");
      this.$ls.remove("nd_data");

      // Ignore cached data and fetch new data
      location.reload(true);
    },
    //Get plot data for region state map
    async getMapPlotData(e) {
      this.mapPlotData = e;
    },
    async getComponentTypeArray(e) {
      this.componentTypeArray = e;
      const allEqual = (arr) => arr.every((v) => v === arr[0]);
      let isElementEqual = allEqual(this.componentTypeArray);
      if (isElementEqual && this.elementToCompare === "source") {
        this.componentType = e[0];
      } else {
        this.componentType = "Charts";
      }
    },
    // Listen for render event
    async chartRendered(e) {
      this.isChartRendered = e;
    },
    async openedMultiselect() {
      this.multiselectPlaceholder = "Search Indicator";
      // this.multiselectPlaceholder = 'Search';
      this.collapsible = true;
    },
    async closedMultiselect(e) {
      this.multiselectPlaceholder = e;
      this.collapsible = true;
    },
    async openedCompareIndicatorMultitselect() {
      this.compareIndicatorMultitselectPlaceholder = "Search Indicator";
      this.collapsible = true;
    },
    async closedCompareIndicatorMultitselect(e) {
      this.compareIndicatorMultitselectPlaceholder = e;
    },
    async openedCompareSourceMultitselect() {
      this.comparisonSelectedSourcePlaceholder = "Search source";
    },
    async closedCompareSourceMultitselect(e) {
      this.comparisonSelectedSourcePlaceholder = e;
    },
    async openedCompareStateMultiselect() {
      this.comparisonSelectedStatePlaceholder = "Search state";
    },
    async closedCompareStateMultiselect(e) {
      this.comparisonSelectedStatePlaceholder = e;
    },
    multiselectSearch() {
      this.collapsible = false;
    },
    openedStateMultiselect() {
      this.statePlaceholder = "Search";
    },
    closedStateMultiselect(e) {
      this.statePlaceholder = e;
    },
    enter() {
      return true;
    },

    scrolldown() {
      this.scrollPage("#bottom_of_page");
      setTimeout(function () {
        document.getElementById("scrollToTopButton").style.display = "block";
        document.getElementById("scrollToButtomButton").style.display = "none";
      }, 500);
    },
    scrollup() {
      this.scrollPage("#top_of_page");
      setTimeout(function () {
        document.getElementById("scrollToButtomButton").style.display = "block";
        document.getElementById("scrollToTopButton").style.display = "none";
      }, 500);
    },

    handleScroll() {
      // console.log(document.documentElement.scrollTop);
      // if (document.body.scrollTop == 0 || document.documentElement.scrollTop == 0 ) {
      //      document.getElementById("scrollToTopButton").style.display = "none";
      //      document.getElementById("scrollToButtomButton").style.display = "block";
      // }
      // else
      // check scroll bar and change scroll display
      if (
        document.body.scrollTop > 500 ||
        document.documentElement.scrollTop > 500
      ) {
        document.getElementById("scrollToTopButton").style.display = "block";
        document.getElementById("scrollToButtomButton").style.display = "none";
        setTimeout(
          function () {
            this.loading = false;
            this.loadingbar = false;
          }.bind(this),
          5000
        );
      } else {
        document.getElementById("scrollToTopButton").style.display = "none";
        document.getElementById("scrollToButtomButton").style.display = "block";
        this.loadingbar = true;

        // setTimeout(function () { this.loading = true; this.loadingbar = false  }.bind(this), 5000)

        // setTimeout(function(){ this.loading = true; this.loadingbar = false }, 3000);
      }
    },
    getCallerComponent(e) {
      this.callerComponentName = e;
    },
    async copyURL() {
      let urlInput = document.getElementById("urlInput");
      urlInput.select();
      document.execCommand("copy");

      this.linkCopied = true;
    },
    async printPage(doc) {
      window.print();
    },
    async hideBarChartClicked(e) {
      this.barChartHidden = e;
    },
    async eyeIconClicked() {
      this.barChartHidden = !this.barChartHidden;
    },
    // shareDashboardState() {
    //   this.shareCounter++;
    // },
    async shareViaEmail() {
      window.location = `mailto:?subject=Central Analytics Repository Dashboard&body=${this.shareURL}`;
    },
    async shareViaFacebook() {
      let facebookURL =
        "https://www.facebook.com/sharer.php?u=" + this.shareURLHash;
      window.open(
        facebookURL,
        "_blank",
        "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480"
      );
    },
    async shareViaTwitter() {
      let facebookURL = `https://twitter.com/share?text=Central Analytics Repository&url=${this.shareURLHash}&hashtags=fmohconnect`;
      window.open(
        facebookURL,
        "_blank",
        "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480"
      );
    },
    async shareViaLinkedin() {
      let linkedinURL = `https://www.linkedin.com/shareArticle?mini=true&url=${this.shareURLHash}&title=Central%20Analytics%20Repository&summary=Health%20Dashboards&source=CAR`;
      window.open(
        linkedinURL,
        "_blank",
        "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480"
      );
    },
    async changeDashboardState(e) {
      let callerName = this.callerComponentName;

      this.dashboardState[callerName] = e;
    },
    /**
     * toggle fullscreen boolean value
     * @param fullscreen | boolean
     */
    async fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    /**
     *
     * Activate the start tour function
     */
    startTour() {
      this.isTourActive = true;
      // Instance the tour
      this.isTourStarts = false;
      this.isTourActive = false;
      introJs().start();
    },
    /**
     *
     * Hide the view for the extended chart section on large screens/TVs but show on smaller screens/PCs
     */
    async showMore(val) {
      if (val == "zonal") {
        this.showMoreFeatures = !this.showMoreFeatures;
        this.showMoreMsg = this.showMoreFeatures
          ? "hide zonal charts"
          : "see zonal charts";
      } else {
        this.showComponents = !this.showComponents;
        this.showCompareMsg = this.showComponents
          ? "hide comparison charts"
          : "see comparison charts";
      }
    },
    /**
     *
     * Hide the view for the extended chart section on large screens/TVs but show on smaller screens/PCs
     */
    async toggleClicked(e) {
      this.isToggleClicked = e;
    },
    async hideBarChart() {
      this.showIcon = true;
    },
    async mouseLeave() {
      this.showIcon = false;
    },
    async IHMEtoggleClicked(e) {
      this.isIHMEtoggleClicked = e;
    },
    async chartSourceData(e) {
      this.dataSourceForChart = e;
    },
    async goto(url) {
      window.open(url);
      //location.href = "https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/";
    },
    async convertToPDF(element_id) {
      var element = document.getElementById(element_id);

      var opt = {
        margin: 1,
        filename: "central_analytics_dashboard.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a3", orientation: "l" },
      };
      // New Promise-based usage:
      html2pdf().from(element).set(opt).save();
    },
    async toggleWidget(param) {
      var widget_num = param.target.id;
      var widget = document.getElementById("widget_" + widget_num);
      widget.parentNode.removeChild(widget);
    },
    async plotUncertainty(e) {
      // toggle show estimate: switch with normal line chart by data sources.
      this.computeUncertaintyTruthVal = !this.computeUncertaintyTruthVal;
      // this.showIHMEEstimate = e;
    },
    async regionalChartYearOptions(e) {
      this.regionalChartYearOptionsData = e;
    },
    async dropdownChangedChart(value, key) {
      this.specificChartType[key] = value;
    },
    async dropdownChangedMap(value, key) {
      this.specificMapType[key] = value;
      // this.specificMapType = value
    },
    async compareIndicators(elemToCompare) {
      // this.elementToCompare = elemToCompare;
      // if(elemToCompare === 'indicator'){
      //   this.isElementToCompareIndicator = true;
      //   this.compareSectionColorClass = true;
      // } else {
      //   this.isElementToCompareIndicator = false;
      //   this.compareSectionColorClass = false;
      // }
      this.showComponents = !this.showComponents;
      // this.specificComponentType = this.specificComponentOptions[0]
      if (this.showComponents) {
        this.scrollPage("#compare-section");
      } else {
        this.scrollPage("#top_of_page");
      }
    },
    async scrollPage(section_id) {
      this.$scrollTo(section_id, 500, {});
    },
    async indicatorRelatives(e) {
      // if (this.showComponents){
      this.relativeIndicators = e;
    },
    async extractStateValuesForIndicator(indicator, selectedSource) {
      var ivt =
        this.$store.state.CAR.indicatorAttributesOtherSources[indicator];
      if (ivt !== undefined) {
        var vt = ivt[1] === "P" ? "%" : "";
        var it = ivt[1] === "P" ? "% of total" : "";
      }
      var stateByIndicatorByYear =
        this.$store.getters.getCurrentIndicatorsValue;
      var selectedIndicatorValuesForEachState = {};

      var indicatorSource = indicator + " -> " + selectedSource;
      var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;

      var statesWithIndicatorsYearAndValues =
        this.getYearWithCurrentIndicatorValues(
          indexOfindicatorSource,
          stateByIndicatorByYear
        );

      if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
        for (var stateName in stateByIndicatorByYear) {
          if (stateName !== undefined) {
            if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
              // var len = stateByIndicatorByYear[stateName].length;
              var stateCurrentYearVals =
                stateByIndicatorByYear[stateName][
                  statesWithIndicatorsYearAndValues[2][stateName]
                ];
              // console.log(stateCurrentYearVals);
              if (stateCurrentYearVals !== undefined) {
                selectedIndicatorValuesForEachState[stateName] = [
                  stateCurrentYearVals[0],
                  stateCurrentYearVals[indexOfindicatorSource],
                ];
              }
            }
          }
        }
      } else {
        selectedIndicatorValuesForEachState =
          statesWithIndicatorsYearAndValues[0];
      }

      var temp = Object.keys(selectedIndicatorValuesForEachState);
      var obj = {};
      temp.map((elem, index) => {
        obj[elem] = selectedIndicatorValuesForEachState[elem][1];
      });

      var regions = [
        "North-East",
        "North-West",
        "North-Central",
        "South-East",
        "South-West",
        "South-South",
      ];
      var sortedObj = sortObjects(obj); // custom method
      var xAxis = [],
        yAxis = [];
      for (let stateName in sortedObj) {
        if (sortedObj.hasOwnProperty(stateName)) {
          if (regions.indexOf(stateName) < 0) {
            // don't need the regions in this chart
            yAxis.push(stateName);
            xAxis.push(sortedObj[stateName]);
          }
        }
      }

      var plotData = {};
      // get the data required for ngMap
      yAxis.map((elem, index) => {
        plotData[elem] = xAxis[index];
      });

      return plotData;
    },

    /**
     *
     * change the main selected indicator as it change on the data table
     * @param selectedIndicator
     */
    async mainSelectedIndicatorFromTable(val) {
      // console.log(val);
      this.selectedIndicator = val;
    },

    async getYearWithCurrentIndicatorValues(
      indexOfindicatorSource,
      stateByIndicatorByYear
    ) {
      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];

      for (var stateName in stateByIndicatorByYear) {
        if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            statesWithIndicatorsYearAndValues[stateName] = [];
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            // if (selectedIndicatorVal) {
            if (
              stateByIndicatorByYear[stateName][i][0] ===
              parseInt(this.selectedYear)
            ) {
              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(
                stateByIndicatorByYear[stateName][i][0],
                stateByIndicatorByYear[stateName][i][indexOfindicatorSource]
              );
              break;
            }
          }
          // get all the years where there's a value for the indicator...
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            if (!sourceActiveYear[stateName]) {
              sourceActiveYear[stateName] = {};
            }
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];

            if (selectedIndicatorVal) {
              sourcetempArr.push(i);
              sourceActiveYear[stateName][
                stateByIndicatorByYear[stateName][i][0]
              ] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
              // break;
            }
          }
        }
      }
      var plotData = {};
      // get the data required for ngMap
      yAxis.map((elem, index) => {
        plotData[elem] = xAxis[index];
      });
      return plotData;
    },
    async getYearWithCurrentIndicatorValues(
      indexOfindicatorSource,
      stateByIndicatorByYear
    ) {
      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];
      for (var stateName in stateByIndicatorByYear) {
        if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            statesWithIndicatorsYearAndValues[stateName] = [];
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            // if (selectedIndicatorVal) {
            if (
              stateByIndicatorByYear[stateName][i][0] ===
              parseInt(this.selectedYear)
            ) {
              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(
                stateByIndicatorByYear[stateName][i][0],
                stateByIndicatorByYear[stateName][i][indexOfindicatorSource]
              );
              break;
            }
          }
          // get all the years where there's a value for the indicator...
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            if (!sourceActiveYear[stateName]) {
              sourceActiveYear[stateName] = {};
            }
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];

            if (selectedIndicatorVal) {
              sourcetempArr.push(i);
              sourceActiveYear[stateName][
                stateByIndicatorByYear[stateName][i][0]
              ] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
              // break;
            }
          }
        }
      }

      // we leverage the fact that National always has data for all the indicators
      this.optionYear = Object.keys(sourceActiveYear["National"]);

      var rowIndex = Math.max.apply(null, tempArr);
      return [statesWithIndicatorsYearAndValues, rowIndex, tempArr];
    },

    async getIndicators() {
      var headerObj = this.$store.getters.getIndicators;
      this.headerObj = headerObj;
      // this.optionIndicators = this.options; // Object.keys(headerObj);
    },

    async getCarData() {
      return this.axios.get(this.apiUrl);
    },

    async getNdState() {
      return this.axios.get(this.ndStateUrl);
    },
    async getNdLga() {
      return this.axios.get(this.ndLgaUrl);
    },

    async getEstimateData() {
      return this.axios.get(this.estimatesUrl);
    },

    getLGAData() {
      return this.axios.get(this.LGA_Url);
    },

    getMetaData() {
      return this.axios.get(this.metaDataUrl);
    },
    getSourceMetaData() {
      return this.axios.get(this.dataSourceUrl);
    },
    getIndicatorMetaData() {
      return this.axios.get(this.indicatorUrl);
    },
    async metaDataValue() {
      let metaData = await this.getMetaData();
      return metaData.data;
    },
    getNhmisMonthly() {
      return this.axios.get(this.nhmisMonthlyUrl);
    },
    generateShareURL() {
      this.shareButtonClicked = true;
      this.dashboardState[selectedIndicator] = this.selectedIndicator.name;
      this.dashboardState.selectedState = this.selectedState;
      let barChartComponentYear =
        this.dashboardState.barChartComponentYear || "";
      let columnChartSource;
      if (Array.isArray(this.dashboardState.columnChartSource)) {
        columnChartSource = [];
        for (var i in this.dashboardState.columnChartSource) {
          columnChartSource.push(this.dashboardState.columnChartSource[i].name);
        }
      } else {
        columnChartSource = this.dashboardState.columnChartSource.name || "";
      }

      let columnChartIndicator = this.dashboardState.columnChartIndicator || "";
      if (this.dashboardState.columnChartIndicator.indexOf("/") > 0) {
        columnChartIndicator =
          this.dashboardState.columnChartIndicator.replace("/", "_") || "";
      }
      let regionsChartYear = this.dashboardState.regionsChartYear || "";
      let selectedIndicator = this.dashboardState[selectedIndicator] || "";
      let selectedState = this.dashboardState.selectedState || "";
      let host = `http://${window.location.hostname}:${window.location.port}`;
      let theURL =
        host +
        `/central_analytics/${selectedIndicator}/${selectedState}/${barChartComponentYear}/${columnChartSource}/${columnChartIndicator}`;
      // this.shareURL = encodeURI(theURL);

      this.urlParams = `${selectedIndicator}&${selectedState}&${barChartComponentYear}&${columnChartSource}&${columnChartIndicator}&${regionsChartYear}`;
      this.shortenURL();
    },
    async shortenURL() {
      this.loadingURLIcon = true;
      this.shortURL = await url_shortener(this.urlParams);
      if (!this.shortURL) {
        this.loadingURLIcon = false;
        this.errorFetchingURL = true;
      } else {
        this.loadingURLIcon = false;
        let hashTag = encodeURIComponent("#");
        let shortened = `http://${window.location.hostname}:${window.location.port}/${hashTag}/central_analytics/${this.shortURL.shortURL}`;
        l;
        this.shareURLHash = shortened;
      }
    },

    async shortenURL_bak() {
      this.loadingURLIcon = true;
      let bitlyLink = `https://api-ssl.bitly.com/v3/shorten?access_token=21fa28d6cfcc24b9600b635288f373cfe28716e2&longUrl=${"http://hybridashforus.surge.sh/central_analytics/National/2017/MICS/Skilled%20attendance%20at%20delivery%20or%20birth"}`;
      let shortURL = await this.axios
        .get(bitlyLink)
        .then((response) => {
          debugger;
          if (response.data.status_code === 200) {
            this.loadingURLIcon = false;
            this.shareURL = response.data.data.url;
          } else {
            this.errorFetchingURL = true;
          }
        })
        .catch((err) => {
          this.loadingURLIcon = false;
          this.errorFetchingURL = true;
          // console.error(err);
        });
    },

    async splitIntoArray(str, divider) {
      return str.split(divider);
    },
    /**
     * Begining of methods for zonal chart/map shared data
     */

    //Get the available years for the currently selected indicator and selected source
    async getYearOptionsWithData(source) {
      // console.log(source);

      let years = [];
      let statesByIndicatorByYear =
        this.$store.getters.getCurrentIndicatorsValue;
      let indicatorSource = this.selectedIndicator.name + " -> " + source;
      let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
      for (var i in statesByIndicatorByYear) {
        statesByIndicatorByYear[i].map((el, i) => {
          if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
            if (years.indexOf(el[0]) < 0) {
              years.push(el[0]);
            }
          }
        });
      }
      years = years.sort();

      this.zonalYearOptions = years;
      if (this.zonalYearOptions.length !== 0) {
        this.zonalSelectedYear =
          this.zonalYearOptions[this.zonalYearOptions.length - 1].toString();
      }
    },

    //Get the available sources for the selected indicator
    getCurrentSourceOptions() {
      let sources = [];
      var statesByIndicatorByYear =
        this.$store.getters.getCurrentIndicatorsValue;
      // console.log(statesByIndicatorByYear);

      for (var k in this.optionSources) {
        for (var i in statesByIndicatorByYear) {
          for (var j in statesByIndicatorByYear[i]) {
            let indicatorSource =
              this.selectedIndicator.name + " -> " + this.optionSources[k];
            let indicatorSourceIndex =
              this.lsData[0].indexOf(indicatorSource) - 1;
            if (
              statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" &&
              indicatorSourceIndex > 0
            ) {
              if (sources.indexOf(this.optionSources[k]) < 0)
                sources.push(this.optionSources[k]);
              break;
            }
          }
        }
      }
      this.zonalSourcesOptions = sources;
      // console.log(this.zonalSourcesOptions);

      if (this.zonalSourcesOptions.includes("NHMIS")) {
        // this.zonalSelectedSource = "NHMIS";
      } else {
        // this.zonalSelectedSource = this.zonalSourcesOptions[0];
      }
    },
    // displays the popup form and sets autoclose timeout
    showForm() {
      this.contactForm = true;
      this.timer = setTimeout(() => {
        this.contactForm = false;
      }, 30000);
    },

    // stops popup form autoclose timeout
    stopTimer() {
      clearTimeout(this.timer);
    },

    //this function gets dashboard query parameters from url if any
    getParamsFromUrl() {
      // if (!this.$route.query.location) {
      //   this.selectedState = "National";
      //   this.$store.dispatch('storeSelectedState',  "National");
      // };
      // if (this.$route.query.location == " ") {
      //   this.selectedState = "National";
      //   this.$store.dispatch('storeSelectedState',  "National");
      // }
      this.$router.push({ query: this.params });
      if (this.$route.query.location) {
        this.params.location = this.$route.query.location;
      }
      if (this.$route.query.indicator) {
        this.params.indicator = this.$route.query.indicator;
      }

      if (this.$route.query.location) {
        // console.log(this.$route.query.location);
        const locationParam = this.$route.query.location;
        //this.dashboardState.selectedState = locationParam;
        this.comparisonSelectedState = locationParam;
        this.$store.dispatch("storeSelectedState", locationParam);
        this.selectedState = locationParam;
        // console.log(this.selectedState);
        //this.isChartRendered = true;
      }

      // if (!this.$route.query.indicator){
      //   this.selectedIndicator.name = "Skilled attendance at delivery or birth";
      //   this.$store.dispatch('storeSelectedIndicator', "Skilled attendance at delivery or birth");
      // }

      if (this.$route.query.indicator) {
        //this.isChartRendered = false;
        const indicatorParam = this.$route.query.indicator;
        this.selectedIndicator = { name: indicatorParam };
        this.$store.dispatch("storeSelectedIndicator", indicatorParam);
        //console.log(this.selectedIndicator.name)
      }
    },
  },
  computed: {
    async myFullscreen() {
      return this.$store.state.CAR.fullscreen;
    },
    async multiselectPlaceholderComputed() {
      this.multiselectPlaceholder = this.selectedIndicator.name;
      this.statePlaceholder = this.selectedState;
      this.compareIndicatorMultitselectPlaceholder =
        this.comparisonSelectedIndicator.name;
      this.comparisonSelectedSourcePlaceholder = this.comparisonSelectedSource;
      // this.comparisonSelectedStatePlaceholder = this.comparisonSelectedState;
      this.comparisonSelectedStatePlaceholder =
        this.$store.state.CAR.selectedState;
    },
    async sourceClicked() {
      var tableColumnHeaderAttr = this.$store.getters.getSourceClicked;

      var sources = tableColumnHeaderAttr[0];
      var val = tableColumnHeaderAttr[1];
      // check for availability of data in the source here

      // var defaultSource = this.$store.getters.getDefaultSource;
      var selectedSource = sources; //? sources: defaultSource;
      // this.selectedSource = selectedSource;

      // get the state indicator source object from store
      var stateSelectedIndicatorSource =
        this.$store.getters.getSelectedIndicatorSource;
      var selectedIndicatorSource =
        stateSelectedIndicatorSource[selectedSource];

      if (selectedIndicatorSource) {
        // compute the years custom to the data
        var optionYear = [];
        Object.keys(stateSelectedIndicatorSource).map((elem, index) => {
          if (stateSelectedIndicatorSource[elem].length > 0) {
            optionYear.push(stateSelectedIndicatorSource[elem][0]);
          }
        });
        //this.optionYear = optionYear; // assign to select year field
        // get the indicator selected, and watch the year of its current value.
        if (selectedIndicatorSource.length > 0) {
          this.selectedYear = selectedIndicatorSource[0];
        }
      }
      return selectedSource;
    },
    relativeIndicatorsValues() {
      var selectedSource = this.sourceClicked;
      var statesValueForIndicator = [];
      this.relativeIndicators.map((elem, index) => {
        statesValueForIndicator.push(
          this.extractStateValuesForIndicator(elem, selectedSource)
        );
      });
      return statesValueForIndicator;
    },

    watchState() {
      return this.$store.state.CAR.selectedState;
    },

    ...mapGetters({
      shareCounter: "getShareCounter",
      zonalChartCounter: "getZonalChartCounter",
      reloadDataState: "getReloadDataState",
      getRelatedIndicators: "getRelatedIndicators",
    }),
  },
  // fetch data before entering the route. This makes things alot faster than
  // when it's done on created.
  async beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.axios
        .all([
          vm.getEstimateData(),
          vm.getLGAData(),
          vm.getMetaData(),
          vm.getSourceMetaData(),
          vm.getIndicatorMetaData(),
          vm.getCarData(),
          vm.getNhmisMonthly(),
        ])
        .then(
          vm.axios.spread(
            (
              estimatesData,
              lgaData,
              metaData,
              sourceMetaData,
              indicatorMetaData,
              carData,
              nhmisMonthlyData
            ) => {
              localStorage.removeItem("clearedDB");
              localStorage.removeItem("clearedDB2");

                const interval = 14;
              // set an initial value to the clearDate key if it doesn't exist
                const year = new Date().getFullYear();
                let month = new Date().getMonth();
                month += 1;
                const day = new Date().getDate();
                const initialDate = `${month}/${day}/${year}`;
              if (localStorage.getItem("clearDate") === null) {
                localStorage.setItem("clearDate", initialDate);
              } else{
              // ======================
              let date = new Date(localStorage.getItem("clearDate"));
              //  =====================

              let time = Date.now() - date.getTime();
              let diff = time / (1000 * 3600 * 24);
              console.log(diff, interval, 'checks');

              if (diff === interval) {
                localStorage.removeItem("car_other_dataset");
                localStorage.removeItem("estimates_dataset");
                localStorage.removeItem("indicator_meta_dataset");
                localStorage.removeItem("meta_data_dataset");
                localStorage.removeItem("nhmis_monthly");
                localStorage.removeItem("source_meta_dataset");
                localStorage.setItem("clearDate", initialDate);
                location.reload();
              }
              }
              // All requests are now complete

              //lga data here ...
              vm.lgaData = lgaData.data;
              // vm.$ls.set("lga_dataset", JSON.stringify(vm.lgaData));
              // vm.$store.dispatch("storeLgaData", { list: vm.lgaData });

              // vm.isDataLoadedFirstTime = true;

              //estimate data here ...
              vm.estimatesData = estimatesData.data;
              vm.$ls.set("estimates_dataset", JSON.stringify(vm.estimatesData));
              // console.log(lgaData);
              // vm.isDataLoadedFirstTime = true;

              // source meta data here ...
              vm.sourceMetaData = sourceMetaData.data;
              vm.$ls.set(
                "source_meta_dataset",
                JSON.stringify(vm.sourceMetaData)
              );
              // vm.$store.dispatch('storeMetaData',{list:vm.lgaData});
              // vm.isDataLoadedFirstTime = true;

              // indicator meta data here ...
              vm.indicatorMetaData = indicatorMetaData.data;
              vm.$ls.set(
                "indicator_meta_dataset",
                JSON.stringify(vm.indicatorMetaData)
              );
              // vm.isDataLoadedFirstTime = true;

              // car data here ...
              vm.lsData = carData.data;
              vm.$ls.set("car_other_dataset", JSON.stringify(vm.lsData));
              vm.$store.dispatch("storeCARData", { list: vm.lsData });

              // meta data here ...
              vm.metaData = metaData.data;
              vm.$ls.set("meta_data_dataset", JSON.stringify(vm.metaData));
              vm.$store.dispatch("storeIndicatorMetaData", vm.metaData);
              // vm.isDataLoadedFirstTime = true;

              // NHmis Monthly Data
              vm.$store.state.CAR.NhmisMonthlyData = nhmisMonthlyData.data;
              vm.$ls.set(
                "nhmis_monthly",
                JSON.stringify(nhmisMonthlyData.data)
              );

              //numerator-denominator data here
              // vm.ndStateData = ndStateData.data;
              // vm.$ls.set('nd_state_data', JSON.stringify(vm.ndStateData));
              //vm.$store.dispatch('storeNdStateData', vm.ndStateData);
              //console.log(vm.ndStateData);

              // vm.ndLgaData = ndLgaData.data;
              // vm.$ls.set('nd_lga_data', JSON.stringify(vm.ndLgaData));
              // vm.$store.dispatch('storeNdLgaData', vm.ndLgaData);
              //console.log(vm.ndLgaData);

              if (!vm.estimatesData) {
                vm.estimatesData = JSON.parse(vm.$ls.get("estimates_dataset"));
              }
              if (!vm.lgaData) {
                vm.lgaData = JSON.parse(vm.$ls.get("lga_dataset"));
              }
              if (!vm.metaData) {
                vm.metaData = JSON.parse(vm.$ls.get("meta_data_dataset"));
              }
              if (!vm.sourceMetaData) {
                vm.sourceMetaData = JSON.parse(
                  vm.$ls.get("source_meta_dataset")
                );
              }
              if (!vm.indicatorMetaData) {
                vm.indicatorMetaData = JSON.parse(
                  vm.$ls.get("indicator_meta_dataset")
                );
              }
              if (!vm.lsData) {
                vm.lsData = JSON.parse(vm.$ls.get("car_other_dataset"));
              }
              // if(!vm.ndStateData){
              //   vm.ndStateData = JSON.parse(vm.$ls.get('nd_state_data'));
              // }
              // if(!vm.ndLgaData){
              //   vm.ndLgaData = JSON.parse(vm.$ls.get('nd_lga_data'));
              // }

              vm.isDataLoadedFirstTime = true;

              //force load static files from server if data is loaded and chart is not rendered after 30secs
              setTimeout(() => {
                if (vm.isChartRendered == false) {
                  this.location.reload(true);
                }
              }, 30000);
            }
          )
        )
        .catch((error) => {
          // if(!vm.lsTargetData){
          //   vm.lsTargetData = JSON.parse(vm.$ls.get('car_targets'));
          // }
          if (!vm.estimatesData) {
            vm.estimatesData = JSON.parse(vm.$ls.get("estimates_dataset"));
          }
          if (!vm.lgaData) {
            vm.lgaData = JSON.parse(vm.$ls.get("lga_dataset"));
          }
          if (!vm.metaData) {
            vm.metaData = JSON.parse(vm.$ls.get("meta_data_dataset"));
          }
          if (!vm.sourceMetaData) {
            vm.sourceMetaData = JSON.parse(vm.$ls.get("source_meta_dataset"));
          }
          if (!vm.indicatorMetaData) {
            vm.indicatorMetaData = JSON.parse(
              vm.$ls.get("indicator_meta_dataset")
            );
          }
          if (!vm.lsData) {
            vm.lsData = JSON.parse(vm.$ls.get("car_other_dataset"));
          }
          // if(!vm.ndStateData){
          //   vm.ndStateData = JSON.parse(vm.$ls.get('nd_state_data'));
          // }
          // if(!vm.ndLgaData){
          //   vm.ndLgaData = JSON.parse(vm.$ls.get('nd_lga_data'));
          // }

          vm.isDataLoadedFirstTime = true;

          //force load static files from server if data is loaded and chart is not rendered after 30secs
          setTimeout(() => {
            if (vm.isChartRendered == false) {
              this.location.reload(true);
            }
          }, 35000);
        });
    });
  },
  // beforeRouteEnter(to, from, next) {}
  // beforeRouteLeave (to, from, next) {},
  async created() {
    // check if user is first time user:::
    var token = Math.random().toString(36).substring(7) + new Date().getTime();

    if (!VueCookies.isKey("firstTimeUser")) {
      VueCookies.set("firstTimeUser", token, "3d");
      this.firstTimeUser = this.firstTimeNotification = true;

      let programArea = [];

      let indicatorArray = [];
      let indicatorAndProgramArea = [];

      let lsMetaData = await this.metaDataValue();

      this.$store.dispatch("indicatorLength", lsMetaData.length - 1);
      this.$store.dispatch("lastUpdated", lsMetaData[0][16]);

      //Dynamically populate program area array from sheet
      let indicatorsAndProgramAreas = {};
      let indicatorAttributes = {};
      let indicatorsRelative = {};
      let shortIndicatorNames = {};

      lsMetaData.slice(1).map((meta, count) => {
        let slope = [];
        let percent = "";

        if (meta[6] in indicatorsAndProgramAreas) {
          indicatorsAndProgramAreas[meta[6]].push(meta[0]);
        } else {
          indicatorsAndProgramAreas[meta[6]] = [];
          indicatorsAndProgramAreas[meta[6]].push(meta[0]);
        }

        if (meta[4] == "Positive") {
          slope = ["G", "R"];
        }
        if (meta[4] == "Negative") {
          slope = ["R", "G"];
        }
        if (meta[3] == "in percentage") {
          percent = "P";
        } else {
          percent = "N";
        }

        indicatorAttributes[meta[0]] = [slope, percent];
        // indicatorsRelative[meta[0]] = [meta[12], meta[13], meta[14], meta[15]]      //For four indicator relatives
        indicatorsRelative[meta[0]] = [meta[12], meta[13]];
        shortIndicatorNames[meta[0]] = meta[1];

        if (programArea.indexOf(meta[6]) < 0) {
          // if(meta[6] === 'Mortality'){
          //   programArea.unshift(meta[6])
          // } else {
          programArea.push(meta[6]);
          // }
        }
      });

      this.$store.dispatch(
        "indicatorsAndProgramAreas",
        indicatorsAndProgramAreas
      );
      this.$store.dispatch("indicatorAttributes", indicatorAttributes);
      this.$store.dispatch("indicatorsRelative", indicatorsRelative);
      this.$store.dispatch("indicatorShortNames", shortIndicatorNames);

      // programArea.sort((a, b) => {
      //   return Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(a) - Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(b);
      // })

      programArea.map((element, index) => {
        let tempArr = [];
        // Structure the indicator names by program areas
        // indicatorArray.map((el,i) => {
        this.metaData.slice(1).map((data, index) => {
          if (element === data[6]) {
            tempArr.push({ name: data[0] });
          }
        });
        // });
        let obj = {
          programArea: element,
          indicators: tempArr,
        };
        indicatorAndProgramArea.push(obj);
      });

      // console.log(indicatorAndProgramArea);

      this.optionIndicators = indicatorAndProgramArea.slice(0);

      /*  End of snippet to get indicator options from the meta data JSON sheet */
    } else {
      this.firstTimeUser = this.firstTimeNotification = false;
      // console.log(this.firstTimeUser);
      /* Begining of snippet to get indicator options from the JSON data */

      let indicatorArray = [];
      let programArea = [];
      let indicatorAndProgramArea = [];
      let indicatorNamesArray = this.lsData[0];

      //Slicing indicator names array to remove period and state name
      indicatorNamesArray.slice(2).map((indicator, index) => {
        if (indicatorArray.indexOf(indicator.split(" -> ")[0]) < 0) {
          indicatorArray.push(indicator.split(" -> ")[0]);
        }
      });

      //Dynamically populate program area array from sheet
      let indicatorsAndProgramAreas = {};
      let indicatorAttributes = {};
      let indicatorsRelative = {};
      let shortIndicatorNames = {};

      this.$store.dispatch("indicatorLength", this.metaData.length - 1);
      this.$store.dispatch("lastUpdated", this.metaData[0][16]);

      this.metaData.slice(1).map((meta, count) => {
        let slope = [];
        let percent = "";

        if (meta[6] in indicatorsAndProgramAreas) {
          indicatorsAndProgramAreas[meta[6]].push(meta[0]);
        } else {
          indicatorsAndProgramAreas[meta[6]] = [];
          indicatorsAndProgramAreas[meta[6]].push(meta[0]);
        }

        if (meta[4] == "Positive") {
          slope = ["G", "R"];
        }
        if (meta[4] == "Negative") {
          slope = ["R", "G"];
        }
        if (meta[3] == "in percentage") {
          percent = "P";
        } else {
          percent = "N";
        }

        indicatorAttributes[meta[0]] = [slope, percent];
        // indicatorsRelative[meta[0]] = [meta[12], meta[13], meta[14], meta[15]]      //For four indicator relatives
        indicatorsRelative[meta[0]] = [meta[12], meta[13]];
        shortIndicatorNames[meta[0]] = meta[1];

        if (programArea.indexOf(meta[6]) < 0) {
          // if(meta[6] === 'Mortality'){
          //   programArea.unshift(meta[6])
          // } else {
          programArea.push(meta[6]);
          // }
        }
      });

      this.$store.dispatch(
        "indicatorsAndProgramAreas",
        indicatorsAndProgramAreas
      );
      this.$store.dispatch("indicatorAttributes", indicatorAttributes);
      this.$store.dispatch("indicatorsRelative", indicatorsRelative);
      this.$store.dispatch("indicatorShortNames", shortIndicatorNames);

      // programArea.sort((a, b) => {
      //   return Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(a) - Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(b);
      // })

      programArea.map((element, index) => {
        let tempArr = [];
        // Structure the indicator names by program areas
        // indicatorArray.map((el,i) => {
        this.metaData.slice(1).map((data, index) => {
          if (element === data[6]) {
            tempArr.push({ name: data[0] });
          }
        });
        // });
        let obj = {
          programArea: element,
          indicators: tempArr,
        };
        indicatorAndProgramArea.push(obj);
      });

      // console.log(indicatorAndProgramArea);

      this.optionIndicators = indicatorAndProgramArea.slice(0);

      /*  End of snippet to get indicator options from the meta data JSON sheet */

      let temp = [];
      this.$store.dispatch("sourceLength", this.sourceMetaData.length - 1);

      this.sourceMetaData.slice(1).map((source, count) => {
        temp.push(source[0]);
      });

      this.optionSources = temp;
      temp = [];
    }
    var tokencheck =
      Math.random().toString(36).substring(7) + new Date().getTime();
    if (!VueCookies.isKey("onBoardingUser")) {
      VueCookies.set("onBoardingUser", tokencheck, "3d");
      this.isTourActive = true;
      // this.isTourActive = false;
    } else {
      this.isTourActive = false;
      //this.isTourActive = true;
    }

    let innerURLParam = this.urlParam;

    let tempOptions = "";
    // async function doDecode() {

    //   if(innerURLParam) {

    //     let url = innerURLParam;
    //     let returnedUrl = await url_decode(url);

    //     return returnedUrl
    //   }

    // }

    // doDecode().then((q) => {

    //   if(q){
    //     this.dashboardStateOptions = q.longURL
    //   }

    // });
    // Add Scroll listener
    // window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    //display contact form after timeout
    setTimeout(() => {
      this.showForm();
    }, 180000);
    setTimeout(() => {
      if (this.detectBrowser() == false) {
        this.detect = true;
      }
    }, 15000);
    if (this.detectBrowser() == false) {
      this.detect = true;
      setTimeout(() => {
        this.closeAlert();
      }, 22000);
    }

    //Listener on the onboarding
    document.addEventListener("keyup", this.nextItem);
    // call get indicator to get indicators

    // Check if URL has a parameter and set dashboard state
    // if(this.dashboardStateOptions){
    //   console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers');

    //   this.dashboardStateOptionsArray = this.splitIntoArray(this.dashboardStateOptions,'&');
    //   this.selectedIndicator.name = this.dashboardStateOptionsArray[0];
    //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
    //   this.selectedState = this.dashboardStateOptionsArray[1];
    // } else {
    //   this.selectedIndicator.name = 'Skilled attendance at delivery or birth';
    //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
    //   this.selectedState = 'National';
    //   this.$store.dispatch('storeSelectedState',  this.selectedState);
    // }
    if (this.lsData) {
      this.getParamsFromUrl();

      // console.log(this.metaData)
      this.getCurrentSourceOptions();
      this.getYearOptionsWithData(this.zonalSelectedSource);
      this.$store.dispatch("storeMultipleSourceData", { list: this.lsData });
      // this.$store.dispatch('storeTargetData',{list:this.lsTargetData})
      // this.getIndicators();        //Used to set header object but not used
      this.isDataLoadedFirstTime = true;
      if (this.firstTimeUser) {
        // setTimeout(this.startTour, 10000);
      }
    }

    //The block below is no longer used since we are getting the data from metaData
    // if (this.lsTargetData) {
    //   this.$store.dispatch('storeTargetData', {list:this.lsTargetData})
    // }

    // forces reload form server if chart is not rendered in 30secs after mounted
    // setTimeout(()=>{
    //   if (!this.isChartRendered) {
    //     location.reload(true);
    //   }
    // },30000);
    this.getCurrentSourceOptions();
  },
  updated() {
    this.isOnline = window.navigator.onLine;
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    /**
     * Watchers for CompareSection component
     */
    watchState(newState, old) {
      this.comparisonSelectedStatePlaceholder = newState;
    },
    params(newValue) {
      this.$router.dispatch("setParams", newValue);
    },

    "$route.query.location"(param) {
      // console.log("url parameters changing");
      // console.log(param);
      //console.log(this.$route.query.location)
      //console.log(this.param);

      //else this.params.indicator = "Skilled attendance at delivery or birth";
      // if (this.$route.query.location) {
      // this.params.location = params.location;
      // }else this.params.indicator = "National";
      if (this.$route.query.location) {
        this.params.location = param;
        // doDecode().then((q) => {

        //   if(q){
        //     this.dashboardStateOptions = q.longURL
        //   }

        // });
        // Add Scroll listener
        // window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener("scroll", this.handleScroll);
      }
    },
    async mounted() {
      this.scroll();

      //display contact form after timeout
      setTimeout(() => {
        this.showForm();
      }, 180000);

      if (this.detectBrowser() == false) {
        this.detect = true;
      }

      setTimeout(() => {
        if (this.detect == true) {
          this.closeAlert();
        }
      }, 15000);

      //Listener on the onboarding
      document.addEventListener("keyup", this.nextItem);
      // call get indicator to get indicators

      // Check if URL has a parameter and set dashboard state
      // if(this.dashboardStateOptions){
      //   console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers');

      //   this.dashboardStateOptionsArray = this.splitIntoArray(this.dashboardStateOptions,'&');
      //   this.selectedIndicator.name = this.dashboardStateOptionsArray[0];
      //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
      //   this.selectedState = this.dashboardStateOptionsArray[1];
      // } else {
      //   this.selectedIndicator.name = 'Skilled attendance at delivery or birth';
      //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
      //   this.selectedState = 'National';
      //   this.$store.dispatch('storeSelectedState',  this.selectedState);
      // }
      if (this.lsData) {
        this.getParamsFromUrl();
      } else {
        this.selectedState = "National";
        this.$store.dispatch("storeSelectedState", "National");
      }

      //this.$router.push({query: this.params});

      //console.log(this.$route.query.location)

      //this.selectedIndicator = "Skilled attendance at delivery or birth"
    },

    "$route.query.indicator"(param) {
      // console.log("indicator param cahnging");
      //console.log(param);
      if (this.$route.query.indicator) {
        this.params.indicator = param;
        this.getParamsFromUrl();
      } else {
        this.selectedIndicator.name = "Skilled attendance at delivery or birth";
        this.$store.dispatch(
          "storeSelectedIndicator",
          "Skilled attendance at delivery or birth"
        );
        comparisonSelectedIndicator.name =
          "Skilled attendance at delivery or birth";
      }
    },

    selectedIndicator({ name }) {
      this.isChartRendered = false;
      // var name = val.name
      //console.log("selected");
      this.$store.dispatch("storeSelectedIndicator", name);

      //this.$store.dispatch('storeSelectedIndicator', name);
      // console.log("selected Indicator");

      this.getCurrentSourceOptions();
      // console.log(this.zonalSelectedSource);

      this.getYearOptionsWithData(this.zonalSelectedSource);
      this.dashboardState.selectedIndicator = name;
      this.params.indicator = name;
      this.$router.push({ query: this.params });
    },

    async selectedState(val) {
      if (this.lsData) {
        //console.log(val);
        this.$store.dispatch("storeSelectedState", val);
        //this.dashboardState.selectedState = val;

        this.params.location = val;
        this.$router.push({ query: this.params });
        //console.log(this.params.location);
      }
    },
    async componentType(val) {
      if (val === "Map") {
        this.specificComponentOptions = ["states", "zones"];
        this.specificComponentType = "states";
        // this.elementToCompare = 'indicator'
      } else {
        this.specificComponentOptions = ["line", "column"];
        this.specificComponentType = "line";
        // this.elementToCompare = 'source'
      }
    },
    async shareCounter(val) {
      if (val > 0) {
        this.generateShareURL();
      }
    },
    // This function is mapped from the store value and is always in sync with the store data
    async zonalChartCounter(val) {
      // console.log(val)
      if (val === "compare-section") {
        this.showComponents = true;
        this.showCompareMsg = this.showComponents
          ? "hide comparison charts"
          : "see comparison charts";
        this.$scrollTo("#compare-section", 300);
      } else if (val !== "") {
        // this.showComponents = false;  //Remove comparison section if val is not empty
        // scroll to the value of the weirdly named field if its not compare section and is also not an empty string
        this.$scrollTo(`#${val}`, 300);
      } else {
        // console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers')
      }
      // Push empty string to store to reset the weirdly named field
      this.$store.dispatch("goToZonalChart", "");
    },
    async reloadDataState(val) {
      if (val) {
        this.clearLocalStorage();
      }
    },
    // async  dashboardStateOptions(val){
    //     if(val){
    //       console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers');

    //       this.dashboardStateOptionsArray = this.splitIntoArray(val,'&');
    //       this.selectedIndicator.name = this.dashboardStateOptionsArray[0];
    //       this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
    //       this.selectedState = this.dashboardStateOptionsArray[1];
    //     } else {
    //       this.selectedIndicator.name = 'Skilled attendance at delivery or birth';
    //       this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
    //       this.selectedState = 'National';
    //       this.$store.dispatch('storeSelectedState',  this.selectedState);
    //     }
    //   },
    async elementToCompare(val) {
      if (val === "indicator") {
        this.isElementToCompareIndicator = true;
      } else {
        this.isElementToCompareIndicator = false;
      }
    },
    async metaData(val) {
      if (val) {
        this.firstTimeNotification = false;
        this.$store.dispatch("storeMetaData", { list: this.val });
      }
    },
    async sourceMetaData(val) {
      if (val) {
        let temp = [];

        val.slice(1).map((source, count) => {
          temp.push(source[0]);
        });

        this.optionSources = temp;
        temp = [];
        // console.log(this.optionSources);
      }
    },
    async lsData(val) {
      if (val) {
        this.getParamsFromUrl();
        this.$store.dispatch("storeCARData", { list: val });
      }

      //Method to get indicator options from the JSON data
      if (val && this.metaData) {
        let indicatorArray = [];
        let programArea = [];
        let indicatorAndProgramArea = [];
        let indicatorNamesArray = this.lsData[0];
        //Slicing indicator names array to remove period and state name
        indicatorNamesArray.slice(2).map((indicator, index) => {
          if (indicatorArray.indexOf(indicator.split(" -> ")[0]) < 0) {
            indicatorArray.push(indicator.split(" -> ")[0]);
          }
        });

        //populate program area array
        this.metaData.slice(1).map((meta, count) => {
          if (programArea.indexOf(meta[6]) < 0) {
            // if(meta[6] === 'Mortality'){
            //   programArea.unshift(meta[6])
            // } else {
            programArea.push(meta[6]);
            // }
          }
        });
        // programArea.sort((a, b) => {
        //   return Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(a) - Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(b);
        // })
        programArea.map((element, index) => {
          let tempArr = [];
          // Structure the indicator names by program areas
          // indicatorArray.map((el,i) => {
          this.metaData.slice(1).map((data, index) => {
            if (element === data[6]) {
              tempArr.push({ name: data[0] });
            }
          });
          // });
          let obj = {
            programArea: element,
            indicators: tempArr,
          };
          indicatorAndProgramArea.push(obj);
        });
        this.optionIndicators = indicatorAndProgramArea.slice(0);
        //End of method to get indicator options from the JSON data
      }
    },
  },
};
</script>

<style scoped>
.mid-align {
  position: absolute;
  top: 20%;
  left: 12.5%;
}
.mid-alignl {
  position: absolute;
  top: 25%;
  left: 12.5%;
}
div#browserSupport {
  position: fixed;
  margin: 5px 5px 0 0;
  background-color: #fff3cd;
  color: #583e03;
  top: 0;
  border: 0.5px solid #583e03;
  font-size: 12px;
  box-shadow: -3px 5px 10px #00000029;
  right: 0;
  border-radius: 5px;
  z-index: 900;
}
div#browserSupport img {
  width: 34px;
  height: 30px;
}
.alertBold {
  color: #583e03;
}
div[class^="col"] {
  padding-left: 7px;
  padding-right: 7px;
}
div[class^="row"] {
  padding-left: -3px;
  padding-right: -3px;
}
.rowlTop {
  margin-bottom: -30px !important;
}
.rowlBot {
  margin-top: -30px !important;
}
/* Some styles live in App.vue file*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#toptab > li:nth-child(5) > a {
  background-color: #007d53 !important ;
  color: white !important ;
}
#toptab > li:nth-child(4) > a {
  background-color: rgb(39, 81, 80) !important ;
  color: white !important ;
}
#toptab > li:nth-child(3) > a {
  background-color: rgb(39, 81, 80) !important ;
  color: white !important ;
}
#toptab > li:nth-child(2) > a {
  background-color: rgb(39, 81, 80) !important ;
  color: white !important ;
}
#toptab > li:nth-child(1) > a {
  background-color: rgb(39, 81, 80) !important ;
  color: white !important ;
}
</style>



// WEBPACK FOOTER //
// MainCarDashboard.vue?7bfd775e